import React, { useEffect, useState } from "react";
import StaticLayout from "../../layout/StaticPageLayout2";
import { useAppDispatch, useAppSelector } from "../../store";
import { SelectFlight } from "../../store/slice/flight";
import {
  dateFormatter,
  isValidEmail,
  numberFormatter,
  replaceSpecialChars,
} from "../../utils/functions";
import { getBookings } from "../../store/service/flight";
import { Button } from "../../layout/component/Button";
import toast from "react-hot-toast";
import { authConfig } from "../../utils/constants";
import { findLocationFromIATA } from "../../utils/data";
import { BsDot } from "react-icons/bs";
import EmptyList from "../../components/EmptyList";

export default function UsersBookings() {
  const { bookings, loading } = useAppSelector(SelectFlight);
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState<string>("");
  const [listLoading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchBookings() {
      const email = localStorage?.getItem(authConfig.usersEmail);
      if (email) {
        await dispatch(getBookings(email));
      }
    }

    fetchBookings();
  }, []);

  return (
    <StaticLayout>
      <div className=" min-h-[300px] py-10 bg-main ">
        <div className=" w-[95%] md:w-[80%] mx-auto font-bold md:text-[20px] pb-8 text-white  ">
          <p className=""> All Bookings</p>
          <div className="flex items-center gap-4 mt-4">
            <input
              type="text"
              required
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email used for booking"
              className=" w-[300px]  text-sm text-black rounded-lg p-2  bg-white/90  outline-none  "
            />
            <Button
              loading={listLoading}
              onClick={async () => {
                if (!isValidEmail(email)) {
                  return toast.error("Invalid email");
                }
                try {
                  setLoading(true);
                  const { message } = await dispatch(
                    getBookings(email)
                  ).unwrap();
                  setLoading(false);
                } catch (error) {
                  setLoading(false);
                }
              }}
              className="bg-secondary text-xs py-3 px-4 "
            >
              Continue
            </Button>
          </div>
        </div>
      </div>

      <div className=" w-[95%] md:w-[80%] mx-auto my-5 ">
        {bookings?.length !== 0 && (
          <div className="block dash_webkit pt- w-full bg-red-00 overflow-x-auto ">
            <table className="w-full bg-green-00">
              <thead className=" bg-form rounded-lg my-2 ">
                <tr className=" text-left  border-b-0  border-[#F6F9F6] ">
                  <th className=" py-2 px-3 tracking-wide whitespace-nowrap  ">
                    <div className=" cursor-pointer w-fit py-2 flex items-center  ">
                      <input
                        type="checkbox"
                        className="w-[14px] h-[14px] cursor-pointer accent-black "
                      />
                    </div>
                  </th>
                  <th className=" py-2 px-3 tracking-wide whitespace-nowrap  ">
                    <div className=" w-full font-normal text-[15px] py-2">
                      TxReference
                    </div>
                  </th>
                  <th className=" py-2 px-3 tracking-wide whitespace-nowrap  ">
                    <div className=" w-full font-normal text-[15px] py-2">
                      From
                    </div>
                  </th>
                  <th className=" py-2 px-3 tracking-wide whitespace-nowrap  ">
                    <div className=" w-full font-normal text-[15px] py-2">
                      To
                    </div>
                  </th>

                  <th className=" py-2 px-3 tracking-wide whitespace-nowrap  ">
                    <div className=" w-full font-normal text-[15px] py-2">
                      Amount
                    </div>
                  </th>

                  <th className=" py-2 px-3 tracking-wide whitespace-nowrap  ">
                    <div className=" w-full font-normal text-[15px] py-2">
                      Status
                    </div>
                  </th>
                  <th className=" py-2 px-3 tracking-wide whitespace-nowrap  ">
                    <div className=" w-full font-normal text-[15px] py-2">
                      Date
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody className=" bg-white rounde ">
                {bookings.map((transaction, index) => (
                  <tr
                    className=" text-left cursor-pointer border-b-[1px]  border-[#F6F9F6] "
                    key={transaction?.id}
                  >
                    <td className=" py-1 w-[30px] px-3 tracking-wide whitespace-nowrap  ">
                      <div className=" w-fit py-4 flex items-center  ">
                        <input
                          type="checkbox"
                          className="w-[14px] h-[14px] accent-red-500 "
                        />
                      </div>
                    </td>
                    <td className=" py-1 px-3 tracking-wide whitespace-nowrap  ">
                      <div className=" w-full py-4  text-[15px] font-semibold    ">
                        {transaction?.transaction_reference}
                      </div>
                    </td>
                    <td className=" py-1 px-3 tracking-wide whitespace-nowrap  ">
                      <div className=" w-full capitalize py-4  text-[15px] font-semibold    ">
                        {findLocationFromIATA(transaction?.departure_id)}
                      </div>
                    </td>
                    <td className=" py-1 px-3 tracking-wide whitespace-nowrap  ">
                      <div className=" w-full capitalize py-4  text-[15px] font-semibold    ">
                        {findLocationFromIATA(transaction?.arrival_id)}
                      </div>
                    </td>
                    <td className=" py-1 px-3 tracking-wide whitespace-nowrap  ">
                      <div className=" w-full py-4  text-[15px] font-semibold    ">
                        ₦
                        {numberFormatter(
                          Number(transaction?.transaction_amount)
                        )}
                      </div>
                    </td>

                    <td className="  tracking-wide whitespace-nowrap  ">
                      <div
                        className={`w-full py-2 flex gap-2 items-center  text-[10px] font-semibold px-3  text-center rounded-full ${
                          transaction?.transaction_status === "APPROVED"
                            ? " bg-reen-400/50 text-green-400 "
                            : transaction?.transaction_status === "CANCELLED"
                            ? " bg-rd-500 text-white "
                            : " bg-yllow-400/50 text-yellow-400 "
                        } `}
                      >
                        <BsDot />{" "}
                        {replaceSpecialChars(transaction?.transaction_status)}
                      </div>
                    </td>
                    <td className=" py-1 px-3 tracking-wide whitespace-nowrap  ">
                      <div className=" w-full py-4  px-3  flex items-center gap-3 text-sm   text-[15px] font-semibold   ">
                        {dateFormatter(transaction?.created_at)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!loading && bookings?.length === 0 && (
          <EmptyList description="No Transaction Record Found" />
        )}
      </div>
    </StaticLayout>
  );
}
